<template>
  <div class="customAgent">
    <el-radio-group 
      v-model="form.require"
      @change="change(form)"
      >
      <el-radio :label="true">是</el-radio>
      <el-radio :label="false">否</el-radio>
    </el-radio-group>
    <div v-if="form.require">
      <!-- <div class="question-title">
        <div>
          代理人姓名+电话
          <span class="question-title-require">
            *
          </span>
        </div>
      </div> -->
      <el-form
        ref="form"
        :model="form"
        label-width="100px"
        size="mini"
      >
        <el-form-item
          label="推荐人姓名"
          required
        >
          <el-input @change="change(form)" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item
          label="推荐人电话"
          required
        >
          <el-input @change="change(form)" v-model="form.tel"></el-input>
        </el-form-item>
      </el-form>
    </div>

  </div>
</template>

<script>
import mixins from "./mixins";

export default {
  name: "customAgent",
  mixins: [mixins],
  data() {
    return {
      radio: undefined,
      form: {},
    };
  },
  methods: {
    change(value) {
      this.answerChange(value);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>